module.exports = __webpack_public_path__ + "static/media/logo-icon.2263c168.svg";